// extracted by mini-css-extract-plugin
export default {"drop-zone":"tnLRBxwT","dragging":"emmu11tq","input":"cJPulpj9"};